var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Hero'),(_vm.articles)?_c('div',{staticClass:"mt-4"},[_c('div',{staticClass:"knowledge-list-heading mb-5"},[_vm._v(" "+_vm._s(_vm.$t("knowledge.search.terms_example", { terms: _vm.$route.query.terms }))+" ")]),_vm._l((_vm.articles),function(article){return _c('Article',{key:article.id,attrs:{"article":article}})})],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }